import { useMemo } from 'react'

/**
 * Fixierter magischer Hintergrund: Aurora-Schleier + Sternenstaub.
 * Liegt hinter dem gesamten App-Inhalt (z-index 0, pointer-events: none).
 */
export function MagicBackground() {
  // Sterne einmalig deterministisch streuen (stabil über Re-Renders).
  const stars = useMemo(
    () =>
      Array.from({ length: 70 }, (_, i) => {
        const seed = (i * 2654435761) >>> 0
        const r1 = ((seed % 1000) / 1000)
        const r2 = (((seed >> 10) % 1000) / 1000)
        const r3 = (((seed >> 20) % 1000) / 1000)
        const size = r3 * 2 + 1
        return {
          left: `${(r1 * 100).toFixed(2)}%`,
          top: `${(r2 * 100).toFixed(2)}%`,
          width: `${size.toFixed(2)}px`,
          height: `${size.toFixed(2)}px`,
          animationDelay: `${(r3 * 3.5).toFixed(2)}s`,
        }
      }),
    [],
  )

  return (
    <div className="mg-bg" aria-hidden="true">
      <div className="mg-bg-aurora" />
      <div className="mg-bg-glow" />
      {stars.map((s, i) => (
        <span
          key={i}
          className="mg-star"
          style={{
            left: s.left,
            top: s.top,
            width: s.width,
            height: s.height,
            animationDelay: s.animationDelay,
          }}
        />
      ))}
    </div>
  )
}
